import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { isNull, isEmpty, toArray } from 'lodash';

import mea from '../../../services/mea';
import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';

import { formatNumber } from '../../../utils';
import { hasCashback } from '../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import CarouselComponent from '../../carousel/CarouselComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import CustomerServiceComponent from '../../CustomerServiceComponent';
import ItemCarrouselComponent from '../../carousel/ItemCarrouselComponent';

import './HomePage.scss';

const carouselOptions = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1
};

export class HomePage extends React.Component {
    componentDidMount() {
        this.props.fetchMeasIfNeeded(mea.constants.CAROUSEL_MEA_TYPE);
        this.props.fetchFaqIfNeeded();
    }

    renderCarouselMeas = () => {
        const { partners, ebonPartners, carrouselMeas } = this.props;

        if ((partners || ebonPartners) && carrouselMeas && carrouselMeas.length > 0) {
            return (
                <section className="accueil-carousel">
                    <CarouselComponent options={carouselOptions}>
                        {carrouselMeas
                            .sort((m1, m2) => m1.ordreAffichage > m2.ordreAffichage)
                            .map((item, i) => {
                                return item.ebon ? (
                                    <ItemCarrouselComponent
                                        item={item}
                                        key={i}
                                        partner={
                                            ebonPartners.find(p => item.idPartenaire === p.id)
                                                ? ebonPartners.find(p => item.idPartenaire === p.id)
                                                : null
                                        }
                                        isEbon
                                    />
                                ) : (
                                    <ItemCarrouselComponent
                                        item={item}
                                        key={i}
                                        partner={
                                            partners[item.idPartenaire]
                                                ? partners[item.idPartenaire]
                                                : null
                                        }
                                        isOffline={item.offline}
                                    />
                                );
                            })}
                    </CarouselComponent>
                </section>
            );
        }
    };

    render() {
        const {
            i18nHome,
            i18nPage,
            BRAND_NAME,
            partnersCount,
            locale,
            faqData,
            i18nCustomerService
        } = this.props;
        const theme = faqData.find(e => !isEmpty(e.faqs)) || null;

        return (
            <React.Fragment>
                <main id="p-accueil-first-half" className="conteneur">
                    <div className="conteneur">
                        <HeadComponent
                            title={i18nHome.TITLE}
                            description={i18nHome.DESCRIPTION}
                            canonicalLink={`${CONTEXT_ROOT}${PATH.HOME_PATH}`}
                        />

                        {this.renderCarouselMeas()}

                        <div className="conteneur-mobile">
                            <HowItWorksComponent showTitle showButtons />
                        </div>
                    </div>
                </main>

                <main id="p-accueil-second-half" className="conteneur conteneur-mobile">
                    <div className="ccm-text">
                        <h3>{convertHtmlToReactDomWithParams(i18nPage.h31, BRAND_NAME)}</h3>
                        <p>
                            {convertHtmlToReactDomWithParams(
                                i18nPage.text1,
                                formatNumber(partnersCount, locale)
                            )}
                        </p>
                        <h3>{i18nPage.h32}</h3>
                        <p>{convertHtmlToReactDomWithParams(i18nPage.text2)}</p>
                    </div>

                    <hr />

                    <div className="help-container grid">
                        <div className="faq-container inbl">
                            <div className="faq-bandeau">{i18nPage.QUESTION}</div>
                            <div className="faq-list-container">
                                {!isNull(theme) &&
                                    theme.faqs
                                        .slice(0, 4)
                                        .map(faq => (
                                            <FaqElementComponent
                                                key={faq.id}
                                                faq={faq}
                                                cssClass="question-comment-ca-marche-page"
                                                forceArrowRight
                                                linkToFaqPage
                                            />
                                        ))}
                            </div>
                        </div>

                        <CustomerServiceComponent i18n={i18nCustomerService} />
                    </div>
                </main>
            </React.Fragment>
        );
    }
}

HomePage.propTypes = {
    partnersCount: PropTypes.number.isRequired,
    carrouselMeas: PropTypes.array,
    i18nHome: PropTypes.object.isRequired,
    partners: PropTypes.object.isRequired,
    faqData: PropTypes.array,
    i18nPage: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    carrouselMeas: mea.selectors.getMeasListByTypeId(state, mea.constants.CAROUSEL_MEA_TYPE),
    partners: state.partner.partners,
    ebonPartners: state.ebon.ebonPartners,
    i18nHome: state.i18n.page.HOME,
    locale: state.i18n.locale,
    partnersCount: toArray(state.partner.partners).filter(partner => hasCashback(partner)).length,
    i18nPage: state.i18n.page.HOW_IT_WORKS,
    i18nCustomerService: state.i18n.feature.aide.serviceclient,
    BRAND_NAME: state.i18n.common.BRAND_NAME,
    faqData: state.faq.faqs || []
});

const mapDispatchToProps = {
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded,
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HomePage),
    PrimaryTemplate,
    {
        hideBreadcrumb: true
    }
);



// WEBPACK FOOTER //
// ./src/components/pages/home/HomePage.js